import React from "react";
import logo from "../../img/logo.svg";
import "./style.scss";

const Header = () => {
  return (
    <div className={"header"}>
      <img src={logo} alt="logo" />
      <a href="/login/" className={"btn btn--sign"}>
        Sign in
      </a>
    </div>
  );
};

export default Header;
